// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   CARD
========================================= */

.LatencyTrendCard_card__D7tpB {
    border-radius: 12px;
    z-index: 1;
    padding: 8px 12px;
    background-color: #ffffff;
}

/* =========================================
   HEADER ACTIONS (Min / Hour / Day + download; the icon style is TCU.module.css .downloadBtn)
========================================= */

.LatencyTrendCard_actions__nPrIz {
    display: flex;
    align-items: center;
    gap: 8px;
}

.LatencyTrendCard_segmented__igDSb {
    display: inline-flex;
    padding: 2px;
    border: 1px solid #c6d9df;
    border-radius: 8px;
    background: #f4f8fc;
}

.LatencyTrendCard_segmentBtn__UP9t- {
    padding: 3px 12px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #6b7280;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

.LatencyTrendCard_segmentBtn__UP9t-:hover {
    color: #022352;
}

.LatencyTrendCard_segmentBtnActive__jDcvQ,
.LatencyTrendCard_segmentBtnActive__jDcvQ:hover {
    background: #4b71a2;
    color: #ffffff;
}

.LatencyTrendCard_segmentBtn__UP9t-:focus-visible {
    outline: 2px solid #4b71a2;
    outline-offset: 1px;
}

/* =========================================
   HOUR TABS (Min view) - browser-style tab strip
========================================= */

/* light-blue frame around the tabs and the chart; the chart sits in a white panel that
   the white active tab flows into, so the chart reads as the selected hour's content */
.LatencyTrendCard_tabFrame__oN-CE {
    margin-top: 2px;
    padding: 0 6px 6px;
    border-radius: 10px;
    background: #e8f0f7;
}

.LatencyTrendCard_tabPanel__HY\\+Im {
    padding: 8px 6px 4px;
    border-radius: 8px;
    background: #ffffff;
}

/* tabs share the width; on narrow screens the strip still scrolls (trackpad, shift + wheel,
   arrow keys) but without a visible scrollbar */
.LatencyTrendCard_hourTabs__I5Uwo {
    position: relative; /* tab offsetLeft is measured from the strip */
    display: flex;
    align-items: flex-end;
    padding: 5px 8px 0;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
}

.LatencyTrendCard_hourTabs__I5Uwo::-webkit-scrollbar {
    display: none;
}

.LatencyTrendCard_hourTab__TLKX0 {
    position: relative;
    flex: 1 1;
    min-width: 46px;
    padding: 6px 4px 7px;
    border: 0;
    border-radius: 8px 8px 0 0;
    background: transparent;
    color: #4b5563;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;
}

/* thin divider between inactive tabs */
.LatencyTrendCard_hourTab__TLKX0::before {
    content: '';
    position: absolute;
    left: 0;
    top: 25%;
    width: 1px;
    height: 50%;
    background: #a9bfd4;
}

/* no divider at the start, next to the active tab, or next to a hovered tab */
.LatencyTrendCard_hourTab__TLKX0:first-child::before,
.LatencyTrendCard_hourTabActive__1PGBM::before,
.LatencyTrendCard_hourTabActive__1PGBM + .LatencyTrendCard_hourTab__TLKX0::before,
.LatencyTrendCard_hourTab__TLKX0:hover::before,
.LatencyTrendCard_hourTab__TLKX0:hover + .LatencyTrendCard_hourTab__TLKX0::before {
    opacity: 0;
}

.LatencyTrendCard_hourTab__TLKX0:hover:not(:disabled):not(.LatencyTrendCard_hourTabActive__1PGBM) {
    background: rgba(255, 255, 255, 0.55);
    color: #022352;
}

.LatencyTrendCard_hourTab__TLKX0:focus-visible {
    outline: 2px solid #4b71a2;
    outline-offset: -2px;
}

/* active: raised white tab, theme blue text */
.LatencyTrendCard_hourTabActive__1PGBM {
    z-index: 1;
    background: #ffffff;
    color: #4b71a2;
    font-weight: 700;
    box-shadow: 0 -1px 2px rgba(16, 24, 40, 0.06);
}

/* curved "feet" that blend the active tab into the chart area */
.LatencyTrendCard_hourTabActive__1PGBM::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: -8px;
    right: -8px;
    height: 8px;
    pointer-events: none;
    background:
        radial-gradient(circle at 0 0, transparent 7.5px, #ffffff 8px) left bottom / 8px 8px no-repeat,
        radial-gradient(circle at 100% 0, transparent 7.5px, #ffffff 8px) right bottom / 8px 8px no-repeat;
}

/* future hours of today */
.LatencyTrendCard_hourTab__TLKX0:disabled {
    color: #a9b4bf;
    cursor: default;
}

/* =========================================
   CHART
========================================= */

.LatencyTrendCard_chartWrap__oGWMU {
    position: relative;
    height: 230px;
}

.LatencyTrendCard_chartState__PThx1 {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #6c757d;
    font-size: 12px;
}

.LatencyTrendCard_spinner__3R4Pd {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid #dee2e6;
    border-top-color: var(--primary-blue-theme-color);
    animation: LatencyTrendCard_spin__4LzzS 0.7s linear infinite;
}

@keyframes LatencyTrendCard_spin__4LzzS {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .LatencyTrendCard_chartWrap__oGWMU {
        height: 200px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .LatencyTrendCard_segmentBtn__UP9t-,
    .LatencyTrendCard_hourTab__TLKX0 {
        transition: none;
    }

    .LatencyTrendCard_spinner__3R4Pd {
        animation-duration: 1.5s;
    }
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/Latency/LatencyTrendCard/LatencyTrendCard.module.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;IACI,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;2CAE2C;;AAE3C;uFACuF;AACvF;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;gDACgD;AAChD;IACI,kBAAkB,EAAE,8CAA8C;IAClE,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAW;IACX,eAAe;IACf,oBAAoB;IACpB,SAAS;IACT,0BAA0B;IAC1B,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yDAAyD;AAC7D;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA,8EAA8E;AAC9E;;;;;IAKI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA,8CAA8C;AAC9C;IACI,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA,gEAAgE;AAChE;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB;;0GAEsG;AAC1G;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;2CAE2C;;AAE3C;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iDAAiD;IACjD,4DAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/* =========================================\n   CARD\n========================================= */\n\n.card {\n    border-radius: 12px;\n    z-index: 1;\n    padding: 8px 12px;\n    background-color: #ffffff;\n}\n\n/* =========================================\n   HEADER ACTIONS (Min / Hour / Day + download; the icon style is TCU.module.css .downloadBtn)\n========================================= */\n\n.actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.segmented {\n    display: inline-flex;\n    padding: 2px;\n    border: 1px solid #c6d9df;\n    border-radius: 8px;\n    background: #f4f8fc;\n}\n\n.segmentBtn {\n    padding: 3px 12px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: #6b7280;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.segmentBtn:hover {\n    color: #022352;\n}\n\n.segmentBtnActive,\n.segmentBtnActive:hover {\n    background: #4b71a2;\n    color: #ffffff;\n}\n\n.segmentBtn:focus-visible {\n    outline: 2px solid #4b71a2;\n    outline-offset: 1px;\n}\n\n/* =========================================\n   HOUR TABS (Min view) - browser-style tab strip\n========================================= */\n\n/* light-blue frame around the tabs and the chart; the chart sits in a white panel that\n   the white active tab flows into, so the chart reads as the selected hour's content */\n.tabFrame {\n    margin-top: 2px;\n    padding: 0 6px 6px;\n    border-radius: 10px;\n    background: #e8f0f7;\n}\n\n.tabPanel {\n    padding: 8px 6px 4px;\n    border-radius: 8px;\n    background: #ffffff;\n}\n\n/* tabs share the width; on narrow screens the strip still scrolls (trackpad, shift + wheel,\n   arrow keys) but without a visible scrollbar */\n.hourTabs {\n    position: relative; /* tab offsetLeft is measured from the strip */\n    display: flex;\n    align-items: flex-end;\n    padding: 5px 8px 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scrollbar-width: none;\n}\n\n.hourTabs::-webkit-scrollbar {\n    display: none;\n}\n\n.hourTab {\n    position: relative;\n    flex: 1 1 0;\n    min-width: 46px;\n    padding: 6px 4px 7px;\n    border: 0;\n    border-radius: 8px 8px 0 0;\n    background: transparent;\n    color: #4b5563;\n    font-size: 11px;\n    font-weight: 600;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n/* thin divider between inactive tabs */\n.hourTab::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 25%;\n    width: 1px;\n    height: 50%;\n    background: #a9bfd4;\n}\n\n/* no divider at the start, next to the active tab, or next to a hovered tab */\n.hourTab:first-child::before,\n.hourTabActive::before,\n.hourTabActive + .hourTab::before,\n.hourTab:hover::before,\n.hourTab:hover + .hourTab::before {\n    opacity: 0;\n}\n\n.hourTab:hover:not(:disabled):not(.hourTabActive) {\n    background: rgba(255, 255, 255, 0.55);\n    color: #022352;\n}\n\n.hourTab:focus-visible {\n    outline: 2px solid #4b71a2;\n    outline-offset: -2px;\n}\n\n/* active: raised white tab, theme blue text */\n.hourTabActive {\n    z-index: 1;\n    background: #ffffff;\n    color: #4b71a2;\n    font-weight: 700;\n    box-shadow: 0 -1px 2px rgba(16, 24, 40, 0.06);\n}\n\n/* curved \"feet\" that blend the active tab into the chart area */\n.hourTabActive::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: -8px;\n    right: -8px;\n    height: 8px;\n    pointer-events: none;\n    background:\n        radial-gradient(circle at 0 0, transparent 7.5px, #ffffff 8px) left bottom / 8px 8px no-repeat,\n        radial-gradient(circle at 100% 0, transparent 7.5px, #ffffff 8px) right bottom / 8px 8px no-repeat;\n}\n\n/* future hours of today */\n.hourTab:disabled {\n    color: #a9b4bf;\n    cursor: default;\n}\n\n/* =========================================\n   CHART\n========================================= */\n\n.chartWrap {\n    position: relative;\n    height: 230px;\n}\n\n.chartState {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    color: #6c757d;\n    font-size: 12px;\n}\n\n.spinner {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 2px solid #dee2e6;\n    border-top-color: var(--primary-blue-theme-color);\n    animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@media (max-width: 768px) {\n    .chartWrap {\n        height: 200px;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .segmentBtn,\n    .hourTab {\n        transition: none;\n    }\n\n    .spinner {\n        animation-duration: 1.5s;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `LatencyTrendCard_card__D7tpB`,
	"actions": `LatencyTrendCard_actions__nPrIz`,
	"segmented": `LatencyTrendCard_segmented__igDSb`,
	"segmentBtn": `LatencyTrendCard_segmentBtn__UP9t-`,
	"segmentBtnActive": `LatencyTrendCard_segmentBtnActive__jDcvQ`,
	"tabFrame": `LatencyTrendCard_tabFrame__oN-CE`,
	"tabPanel": `LatencyTrendCard_tabPanel__HY+Im`,
	"hourTabs": `LatencyTrendCard_hourTabs__I5Uwo`,
	"hourTab": `LatencyTrendCard_hourTab__TLKX0`,
	"hourTabActive": `LatencyTrendCard_hourTabActive__1PGBM`,
	"chartWrap": `LatencyTrendCard_chartWrap__oGWMU`,
	"chartState": `LatencyTrendCard_chartState__PThx1`,
	"spinner": `LatencyTrendCard_spinner__3R4Pd`,
	"spin": `LatencyTrendCard_spin__4LzzS`
};
export default ___CSS_LOADER_EXPORT___;
